import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const FloatingBall = () => {
  useEffect(() => {
    const container = document.getElementById("container");

    const createShape = () => {
      const shape = document.createElement("span");
      shape.className = "shape";
      container.appendChild(shape);

      const size = Math.random() * 50 + 20; 
      const color = getRandomColor();
      const duration = Math.random() * 5 + 2; 

      shape.style.width = `${size}px`;
      shape.style.height = `${size}px`;
      shape.style.backgroundColor = color;

      const initialX = Math.random() * window.innerWidth;
      const initialY = Math.random() * window.innerHeight;

      shape.style.transform = `translate(${initialX}px, ${initialY}px)`;

      setTimeout(() => {
        container.removeChild(shape);
      }, duration * 1000);
    };

    const getRandomColor = () => {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    };

    const intervalId = setInterval(createShape, 1000); 

    return () => clearInterval(intervalId);
  }, []);

  return <Container id="container" />;
};

export default FloatingBall;